import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from 'containers/Layout'
import { Route, Switch, useHistory, useParams } from 'react-router-dom'
import PartnerProfile from 'pages/partner/PartnerProfile'
import apiGet from 'lib/network/apiGet'
import { getResourceData } from 'lib/utils/resource'

const AddEditPartner = ({ readOnly, currentPartnerId, selfService = false }) => {
  const { t } = useTranslation()
  const history = useHistory()

  const [isEdit, setIsEdit] = useState(null)
  const [partnerData, setPartnerData] = useState({})
  const [loading, setLoading] = useState(false)

  const id = useParams()?.id || currentPartnerId

  useEffect(() => {
    if (id) {
      setIsEdit(true)
      fetchPartner(id)
    }
  }, [id])

  const backPath = selfService ? '/bookings' : '/partners'

  const fetchPartner = async () => {
    setLoading(true)
    try {
      const data = getResourceData(await apiGet(`partner/${id}`))

      if (!data) {
        history.push(backPath)
        return
      }

      setPartnerData(data)
    } catch (error) {
      console.error('Error fetching partner:', error)
      history.push(backPath)
    } finally {
      setLoading(false)
    }
  }
  const pageTitle = selfService ? t('sidebar.partnerSettings') : isEdit ? t('addEditPartner.title.edit') : t('addEditPartner.title.add')
  const breadcrumbs = selfService
    ? [
        { name: t('sidebar.bookings'), pathname: '/bookings' },
        { name: t('sidebar.partnerSettings'), pathname: '/partner/settings', current: true },
      ]
    : [
        { name: t('addEditPartner.breadcrumbs.partners'), pathname: '/partners' },
        { name: isEdit ? t('addEditPartner.breadcrumbs.partnerDetails') : t('addEditPartner.breadcrumbs.addNewPartner'), pathname: '/partners/add', current: true },
      ]

  return (
    <Layout
      headerRight={
        <div className="mt-4 flex sm:mt-0 sm:ml-4">
          <button
            onClick={() => {
              history.push(backPath)
            }}
            type="button"
            className="order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm text-normal rounded-md text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500 sm:order-1 sm:ml-3"
          >
            {t('addEditPartner.buttons.goBack')}
          </button>
        </div>
      }
      title={pageTitle}
      breadcrumbs={breadcrumbs}
    >
      <div className="flex overflow-auto">
        {currentPartnerId ? (
          <PartnerProfile readOnly={readOnly} selfService={selfService} refetch={fetchPartner} partnerData={partnerData} loading={loading} id={id} isEdit={isEdit} />
        ) : (
          <Switch>
            <Route key={id} path="/partners/add" component={() => <PartnerProfile id={id} isEdit={isEdit} />} />
            <Route
              key={id}
              path="/partners/edit/:id"
              component={() => <PartnerProfile readOnly={readOnly} refetch={fetchPartner} partnerData={partnerData} loading={loading} id={id} isEdit={isEdit} />}
            />
          </Switch>
        )}
      </div>
    </Layout>
  )
}

export default AddEditPartner
